import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import { PDFDownloadLink, pdf, Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { Field, Formik, ErrorMessage } from "formik";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { InitialData } from "../../common/InitialData";
import {
  checkValidations,
  convertObject,
  isAnyKeyEmpty,
  reverseObject,
} from "../../common/Utilities";
import {
  COE_Category,
  CustomerIDType,
  Vehicle_emission_scheme,
  nationalityList,
} from "../../common/Constants";
import dayjs from "dayjs";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import FileUploadWithThumbnails from "./FileUploadWithThumbnails";
import { IMAGE_BASE_URL } from "../../common/Constants";
import { isBrowser, isMobile } from 'react-device-detect';
import VehicleDetailsPDF from "./GeneratePdf";
import VehicleDocuments from "./VehicleDocuments";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const VehicleDetails = ({
  opcData,
  updateFunction,
  productData,
  filterData,
  RetriveVehicleData,
  RetriveVehicleDetails,
  loading,
  setLogFile,
  loanDetails
}) => {
  const formikRef = useRef(null);
  const navigate = useNavigate();
  let vehicleDocuments = localStorage.getItem('vehicleDocuments');
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [parsedPDFData, setParsedPDFData] = useState({});
  const applicationno = localStorage.getItem("applicationno");
  const [validationDetails, setValidationDetails] = useState({});
  const [vehicleLoanTypeData, setVehicleLoanTypeData] = useState("");
  const [vehicelDetail, setVehicleDetail] = useState({});
  const [settings, setSettings] = useState({});
  const { TextArea } = Input;
  const [logcardText, setLogcardText] = useState('');
  const [isParsed, setIsParsed] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [tempAccessCode, setTempAccessCode] = useState("");
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessages, setErrorMessages] = useState("");
  const [opcSearch, setOpcSearch] = useState(false);
  const [tag, setTag] = useState(null);

  const DeafultVehicleForm = {
    vehicle_reg_no: '',
    access_code: '',
    make_model: '',
    vehicle_yom: '',
    vehicle_engine_no: '',
    vehicle_chassis_no: '',
    vehicle_omv: '',
    vehicle_ori_reg_date: '',
    vehicle_coe_amount: '',
    arf_paid: '',
    transfer_count: '',
    vehicle_purchase_price: '',
    opc_vehicle_id: 0,
  };

  const handleBlur = (e, formikProps) => {
    const { name, value } = e.target;
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);

    //LTV%
    if (name === "vehicle_purchase_price") {
      console.log("inside")
      const purchasePrice = parseFloat(value);
      const loanAmount = parseFloat(loanDetails?.loanamount || 0);
      if (!isNaN(purchasePrice) && purchasePrice > 0 && !isNaN(loanAmount)) {
        const ltv = (loanAmount / purchasePrice) * 100;
        formikProps.setFieldValue("loan_to_value", ltv.toFixed(2));
      } else {
        formikProps.setFieldValue("loan_to_value", "");
      }
    }

    const updateData = convertObject({ ...formikProps.values, [name]: value });
    setValidationDetails(updateData);

    localStorage.setItem("vehicleDetails", JSON.stringify(updateData));
  };

  const {
    reset,
    setValue,
    watch,
  } = useForm();

  const parseLogcardText = async (text, formikProps) => {
    const newParsedData = {};
    const knownSectionHeaders = [
      "Vehicle Owner Particulars",
      "Vehicle Details",
      "Vehicle to be Exported",
      "Intended Deregistration Date",
      "Intended PARF Rebate Details",
      "Intended COE Rebate Details",
      "Message"
    ];

    const extractValue = (line) => {
      const match = line.match(/:\s*(.*)/);
      return match ? match[1].trim() : line.trim();
    };

    const fieldsMap = [
      { label: /Owner ID Type/i, field: 'customer_id_type' },
      { label: /Owner ID/i, field: 'owner_id' },

      { label: /Vehicle No\./i, field: 'vehicle_reg_no' },
      { label: /Vehicle to be Exported/i, field: 'is_vehicle_exported' },
      { label: /Intended Deregistration Date/i, field: 'intended_reg_date' },
      { label: /Vehicle Make/i, field: 'vehicle_make' },
      { label: /Vehicle Model/i, field: 'make_model' },
      { label: /Primary Colour/i, field: 'vehicle_color' },
      { label: /Manufacturing Year/i, field: 'vehicle_yom' },
      { label: /Engine No\./i, field: 'vehicle_engine_no' },
      { label: /Chassis No\./i, field: 'vehicle_chassis_no' },
      { label: /Maximum Power Output/i, field: 'maximum_power' },
      { label: /Open Market Value/i, field: 'vehicle_omv' },
      { label: /Original Registration Date/i, field: 'vehicle_ori_reg_date' },
      { label: /First Registration Date/i, field: 'vehicle_first_reg_date' },
      { label: /Transfer Count/i, field: 'transfer_count' },
      { label: /Actual ARF Paid/i, field: 'arf_paid' },

      { label: /^OPC$/i, field: 'vehicle_opc' },

      { label: /PARF Eligibility Expiry Date/i, field: 'parf_eligibility_expiry_date' },
      { label: /PARF Eligibility/i, field: 'parf_eligibility' },
      { label: /PARF Rebate Amount/i, field: 'parf_rebate' },

      { label: /COE Rebate Amount/i, field: 'coe_rebate' },
      { label: /COE-QP \/ PQP Paid|QP Paid/i, field: 'vehicle_coe_amount' },
      { label: /^QP Paid$/i, field: 'vehicle_coe_amount' },
      { label: /^PQP Paid$/i, field: 'vehicle_pqp_paid_amount' },
      { label: /COE Category/i, field: 'vehicle_coe_category' },
      { label: /COE Expiry Date/i, field: 'coe_expiry_date' },
      { label: /COE Period(?:\s*\(Years\))?/i, field: 'vehicle_coe_periods' },

      { label: /Will This Vehicle be Registered under OPC\?/i, field: 'vehicle_under_opc' },
      { label: /Is this an OPC Vehicle\?/i, field: 'opc_vehicle_id' },
      { label: /Purchase Price/i, field: 'vehicle_purchase_price' },
      { label: /Selling Price/i, field: 'selling_price' },
      { label: /Loan to value/i, field: 'loan_to_value' },
      // { label: /Total Rebate Amount/i, field: 'total_rebate' },
    ];


    const lines = text.split(/\r?\n/);

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      for (const { label, field } of fieldsMap) {
        if (label.test(line)) {
          let value = extractValue(line);
          if (!value && i + 1 < lines.length) {
            const nextLine = lines[i + 1].trim();
            const isLabel = fieldsMap.some(f => f.label.test(nextLine));
            const isSection = knownSectionHeaders.includes(nextLine);

            if (!isLabel && !isSection) {
              value = extractValue(nextLine);
              i++;
            }
          }
          if (value) {
            newParsedData[field] = value.replace(/[$,]/g, '').trim();
          }
        }
      }
    }

    const fieldMap = {
      "Owner ID Type": "customer_id_type",
      "Owner ID": "owner_id",
      "Vehicle No.": "vehicle_reg_no",
      "Vehicle to be Exported": "is_vehicle_exported",
      "Intended Deregistration Date": "intended_reg_date",
      "Access Code": "access_code",
      "Vehicle Make": "vehicle_make",
      "Vehicle Model": "make_model",
      "Primary Colour": "vehicle_color",
      "Manufacturing Year": "vehicle_yom",
      "Engine No.": "vehicle_engine_no",
      "Chassis No.": "vehicle_chassis_no",
      "Maximum Power Output": "maximum_power",
      "Open Market Value": "vehicle_omv",
      "Original Registration Date": "vehicle_ori_reg_date",
      "First Registration Date": "vehicle_first_reg_date",
      "Transfer Count": "transfer_count",
      "Actual ARF Paid": "arf_paid",

      "OPC": "vehicle_opc",

      "PARF Eligibility": "parf_eligibility",
      "PARF Eligibility Expiry Date": "parf_eligibility_expiry_date",
      "PARF Rebate Amount": "parf_rebate",

      "COE Rebate Amount": "coe_rebate",
      "QP Paid": "vehicle_coe_amount",
      "PQP Paid": "vehicle_pqp_paid_amount",
      "COE Category": "vehicle_coe_category",
      "COE Expiry Date": "coe_expiry_date",
      "COE Period(Years)": "vehicle_coe_periods",
      // "OPC Cash Rebate Amount": "opc_rebate",
      // "OPC Cash Rebate Eligibility Expiry Date": "opc_eligibility_expiry_date",
      // "Total Rebate Amount": "total_rebate",

    };
    // localStorage.setItem('vehicleRawText', text);

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      const fieldKey = fieldMap[line];

      if (fieldKey) {
        let j = i + 1;
        while (j < lines.length && lines[j].trim() === "") j++;

        if (j < lines.length) {
          let value = lines[j].trim().replace(/[$,]/g, '');
          if (value) newParsedData[fieldKey] = value;
          i = j;
        }
      }
    }

    const formAccessCode = formikProps.values.access_code?.trim() || "";
    const modalAccessCode = tempAccessCode?.trim() || "";
    const currentAccessCode = formAccessCode || modalAccessCode;
    const mergedData = { ...newParsedData };

    if (!mergedData.access_code && currentAccessCode) {
      mergedData.access_code = currentAccessCode;
    }
    const finalData = { ...formikProps.values, ...mergedData };

    Object.entries(finalData).forEach(([key, value]) => {
      if (formikProps.values.hasOwnProperty(key)) {
        formikProps.setFieldValue(key, value);
      }
    });
    setVehicleDetail(finalData);
    localStorage.setItem("vehicleDetails", JSON.stringify(convertObject(finalData)));


    const qpPaid = newParsedData.vehicle_coe_amount;
    const pqpPaid = newParsedData.vehicle_pqp_paid_amount;
    const orgDate = newParsedData.vehicle_ori_reg_date;
    const firstDate = newParsedData.vehicle_first_reg_date;
    const coeCategory = (newParsedData.vehicle_coe_category || "").toUpperCase()[0];

    const products = loanDetails?.products || {};
    const firstProduct =
      products?.Bank?.[0] ||
      products?.["Financial_Institution"]?.[0] ||
      products?.["In-House"]?.[0];
    const vehicleName = firstProduct?.vehicle?.name?.toUpperCase() || "-";

    const type = loanDetails?.typeinfo?.name || "-";

    // Search OPC
    const opcSearch = text.toUpperCase().includes("OPC");
    console.log("is opc or not ==", opcSearch)
    setOpcSearch(opcSearch);

    // validation of pasted input
    const validationErrors = [];

    const validateVehicle = () => {
      const vehicleType = vehicleName?.toUpperCase();

      const isPARF = type?.toUpperCase() === "PARF";
      const isCOE = type?.toUpperCase() === "COE";

      const vehicleConfig = {
        CAR: {
          PARF: {
            normal: {
              checks: () => {
                if (!coeCategory || !["A", "B", "E"].includes(coeCategory)) {
                  validationErrors.push("COE");
                }
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP ");
              },
              tag: "PARF Veh. - [PARF]",
            },
            importUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["A", "B", "E"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "PARF Veh. - [PARF - Import Used]",
            },
            opc: {
              checks: () => {
                if (!coeCategory || !["A", "B", "E"].includes(coeCategory)) {
                  validationErrors.push("Invalid COE category provided.");
                }
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
              },
              tag: "PARF Veh. - [OPC - PARF]",
            },
            opcImportUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["A", "B", "E"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "OPC PARF Veh. - [OPC PARF– Car. Veh. – Import Used]",
            },
          },
          COE: {
            normal: {
              checks: () => {
                if (!coeCategory || !["A", "B", "E"].includes(coeCategory)) {
                  validationErrors.push("Invalid COE category provided.");
                }
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("PQP must be paid before proceeding.");
              },
              tag: "COE Veh. - [COE]",
            },
            importUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("PQP Paid not being paid.");
                if (!["A", "B", "E"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "Import Used Veh. - [COE - Import Used]",
            },
            opc: {
              checks: () => {
                if (!coeCategory || !["A", "B", "E"].includes(coeCategory)) {
                  validationErrors.push("Invalid COE category provided.");
                }
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("QP Paid not being paid.");
              },
              tag: "COE Veh. - [OPC - COE]",
            },
            opcImportUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["A", "B", "E"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "OPC COE Veh. - [OPC COE - Car. Veh. – Import Used]",
            },
          },
        },
        COMMERCIAL: {
          PARF: {
            normal: {
              checks: () => {
                if (!coeCategory || !["C"].includes(coeCategory)) {
                  validationErrors.push("Invalid COE category provided.");
                }
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
              },
              tag: "PARF Veh. - [PARF - Com. Veh.]",
            },
            importUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["C"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "PARF Veh. - [PARF - Com. Veh. - Import Used]",
            },
            opc: {
              checks: () => {
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["C"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "PARF Veh. - [OPC - PARF - Com. Veh.]",
            },
            opcImportUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["C"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "OPC PARF Veh. - [OPC PARF - Com. Veh. - Import Used]",
            },
          },
          COE: {
            normal: {
              checks: () => {
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("PQP must be paid before proceeding.");
                if (!["C"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "COE Veh. - [COE - Com. Veh.]",
            },
            importUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("PQP Paid not being paid.");
                if (!["C"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "Import Used Veh. - [COE - Com. Veh. - Import Used]",
            },
            opc: {
              checks: () => {
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("QP Paid not being paid.");
                if (!["C"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "COE Veh. - [OPC - COE - Com. Veh.]",
            },
            opcImportUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("QP Paid not being paid.");
                if (!["C"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "OPC COE Veh. - [OPC COE - Com. Veh. - Import Used]",
            },
          },
        },
        MOTORCYCLE: {
          PARF: {
            normal: {
              checks: () => {
                if (!coeCategory || !["D"].includes(coeCategory)) {
                  validationErrors.push("Invalid COE category provided.");
                }
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
              },
              tag: "PARF Veh. - [PARF - Mot. Veh.]",
            },
            importUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["D"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "PARF Veh. - [PARF - Mot. Veh. - Import Used]",
            },
            opc: {
              checks: () => {
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["D"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "PARF Veh. - [OPC - PARF - Mot. Veh.]",
            },
            opcImportUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!qpPaid) validationErrors.push("QP must be paid before proceeding.");
                if (!["D"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "OPC PARF Veh. - [OPC PARF - Mot. Veh. - Import Used]",
            },
          },
          COE: {
            normal: {
              checks: () => {
                if (!coeCategory || !["D"].includes(coeCategory)) {
                  validationErrors.push("Invalid COE category provided.");
                }
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("PQP must be paid before proceeding.");
              },
              tag: "COE Veh. - [COE - Mot. Veh.]",
            },
            importUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("PQP Paid not being paid.");
                if (!["D"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "Import Used Veh. - [COE - Mot. Veh. - Import Used]",
            },
            opc: {
              checks: () => {
                if (orgDate !== firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("QP Paid not being paid.");
                if (!["D"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "COE Veh. - [OPC - COE - Mot. Veh.]",
            },
            opcImportUsed: {
              checks: () => {
                if (orgDate === firstDate)
                  validationErrors.push("Original Date does not match First Registration Date.");
                if (!pqpPaid) validationErrors.push("QP Paid not being paid.");
                if (!["D"].includes(coeCategory))
                  validationErrors.push("Invalid COE category provided.");
              },
              tag: "OPC COE Veh. - [OPC COE - Mot. Veh. - Import Used]",
            },
          },
        },
      };

      // for field TAG
      let catKey;
      if (opcSearch) {
        catKey = orgDate === firstDate ? "opc" : "opcImportUsed";
      } else {
        catKey = orgDate === firstDate ? "normal" : "importUsed";
      }

      const typeKey = isPARF ? "PARF" : isCOE ? "COE" : null;
      const config =
        vehicleConfig?.[vehicleType]?.[typeKey]?.[catKey];

      // for popup TAG
      let popupVehicleType;
      if (["A", "B", "E"].includes(coeCategory?.toUpperCase().trim())) {
        popupVehicleType = "CAR";
      } else if (coeCategory?.toUpperCase().trim() === "C") {
        popupVehicleType = "COMMERCIAL";
      } else if (coeCategory?.toUpperCase().trim() === "D") {
        popupVehicleType = "MOTORCYCLE";
      } else {
        popupVehicleType = "CAR";
      }

      let popupTypeKey;
      if (qpPaid) {
        popupTypeKey = "PARF";
      } else if (pqpPaid) {
        popupTypeKey = "COE";
      } else {
        popupTypeKey = typeKey;
      }

      const popUpTag = vehicleConfig?.[popupVehicleType]?.[popupTypeKey]?.[catKey];

      let tags = null;
      if (config) {
        config.checks();
        if (validationErrors.length === 0) {
          // console.log("no error")
          setTag(config.tag);
          tags = config.tag;
        } else {
          console.log("error found")
          setTag(null);
          setErrorMessages(
            "The selected loan product is under the " +
            vehicleName +
            " " +
            type +
            " category, but the uploaded log card details are for the " +
            popUpTag.tag +
            " category. Please re-select the correct loan product or upload the proper log card details."
          );
          setErrorModalVisible(true);
        }
      } else {
        setTag(null);
        setErrorMessages("Invalid vehicle configuration.");
        setErrorModalVisible(true);
      }

      return tags;
    };

    let tags = validateVehicle();

    if (validationErrors.length === 0) {
      const blob = await pdf(<VehicleDetailsPDF data={mergedData} selectBox={loanDetails} tag={tags} isOPC={opcSearch} />).toBlob();
      const fileName = mergedData.vehicle_reg_no + '.pdf';
      const file = new File([blob], fileName, { type: 'application/pdf' });
      mergedData.file = file;
      setParsedPDFData(mergedData);
      RetriveVehicleData(mergedData, formikProps);
    }
    localStorage.setItem('vehicleRawText', text);
    localStorage.setItem('logcardParsed', 'true');
    setIsParsed(true);
  };
  const currencyFormatter = (value) => {
    if (!value) return "";
    const num = parseFloat(value.toString().replace(/[^0-9.]/g, ""));
    if (isNaN(num)) return "";
    return `$${num.toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
  };

  const currencyParser = (value) => {
    if (!value) return "";
    return value.replace(/[^0-9.]/g, "");
  };

  const handleChange = (e, formikProps) => {
    const { name, value } = e.target;
    let data = { ...formikProps.values };
    if (name == "opc_vehicle_id" && value == 0) {
      data["is_opc_car"] = 0;
      data["opc_vehicle_id"] = 0;
    } else if (name == "opc_vehicle_id" && value != 0) {
      data["is_opc_car"] = 1;
      data["opc_vehicle_id"] = value;
    }
    if (name == "vehicle_under_opc") {
      data["vehicle_under_opc"] = value;
    }
    let updateData = data;
    updateData = convertObject(data);
    if (updateData["vehicle_under_opc"] != undefined) {
      if (updateData["vehicle_under_opc"]["value"] == 0) {
        updateData["vehicle_under_opc"]["validation"] = true;
      }
    }
    if (updateData["opc_vehicle_id"] != undefined) {
      if (updateData["opc_vehicle_id"]["value"] == 0) {
        updateData["opc_vehicle_id"]["validation"] = true;
        updateData["is_opc_car"]["validation"] = true;
      }
    }
    setVehicleDetail(data);
    setValidationDetails(updateData);
    localStorage.setItem("vehicleDetails", JSON.stringify(updateData));
  };

  const handleDropdownChange = (name, value, formikProps) => {
    let data = { ...vehicelDetail };
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    data[name] = value;
    setVehicleDetail(data);
    let updateData = data;
    updateData = convertObject(data);
    setValidationDetails(updateData);
    localStorage.setItem("vehicleDetails", JSON.stringify(updateData));
  };

  // localstorage - GET
  useEffect(() => {
    const fromBack = sessionStorage.getItem('fromBackButton');
    const getData = localStorage.getItem('vehicleRawText');
    const parsedFlag = localStorage.getItem('logcardParsed');

    if (!fromBack) {
      // console.log(fromBack)
      localStorage.removeItem("vehicleDetails");
    }

    if (fromBack === 'true') {
      if (getData) {
        setLogcardText(getData);
      }
      if (parsedFlag === 'true') {
        setIsParsed(true);
      }
      sessionStorage.removeItem('fromBackButton');
    }
  }, []);

  useEffect(() => {
    const savedValues = localStorage.getItem("vehicleDetails");
    if (savedValues) {
      let parsedValues = JSON.parse(savedValues);
      setValidationDetails(parsedValues);
      parsedValues = reverseObject(parsedValues);
      setVehicleDetail(parsedValues);

      Object.entries(parsedValues).forEach(([key, value]) => {
        formikRef.current?.setFieldValue(key, value);
      });
    }
  }, []);



  useEffect(() => {
    const savedValues = localStorage.getItem("vehicleDetails");
    const VehicleLoanType = filterData;
    if (savedValues) {
      let parsedValues = JSON.parse(savedValues);
      setValidationDetails(parsedValues);
      parsedValues = reverseObject(parsedValues);
      setVehicleDetail(parsedValues);
      if (parsedValues.access_code) {
        formikRef.current?.setFieldValue("access_code", parsedValues.access_code);
      }
    } else {
      if (VehicleLoanType.category === "f96b81ae-7210-4332-80d2-070556ea724b") {
        setVehicleDetail(InitialData.vehicle_details_new);
      } else {
        setVehicleDetail(InitialData.vehicle_details);
      }
    }

    if (VehicleLoanType) {
      setVehicleLoanTypeData(VehicleLoanType.category);
    }
  }, []);

  useEffect(() => {
    async function GetSettings() {
      let res = await axios.get("/settings");
      setSettings(res.data?.data);
    }
    GetSettings();
  }, []);

  useEffect(() => {
    if (
      RetriveVehicleDetails !== undefined &&
      RetriveVehicleDetails !== null &&
      Object.keys(RetriveVehicleDetails)?.length > 0
    ) {
      setVehicleDetail(RetriveVehicleDetails);
    }
  }, [RetriveVehicleDetails]);

  const validateAccessCode = (formikProps) => {
    const accessCodeValue = formikProps.values.access_code?.trim();
    if (!accessCodeValue) {
      setTempAccessCode("");
      setModalMessage("Access Code is required!");
      setIsModalVisible(true);
      return false;
    }
    return true;
  };

  const handleRedo = (formikProps) => {
    localStorage.removeItem('logcardParsed');
    localStorage.removeItem('vehicleDetails');
    localStorage.removeItem('vehicleDocuments');
    setIsParsed(false);
    setTag(null);

    const cleared = convertObject(DeafultVehicleForm);
    Object.entries(DeafultVehicleForm).forEach(([key, val]) => {
      formikProps.setFieldValue(key, val);
    });
    setVehicleDetail(DeafultVehicleForm);
    // console.log("cleared--", cleared)
    setValidationDetails(cleared);
  };
  return (
    <div>
      <Formik
        innerRef={formikRef}  // <-- Pass the ref here
        initialValues={DeafultVehicleForm}
        // initialValues={vehicelDetail || DeafultVehicleForm}
        enableReinitialize={true}  // important if state changes
        onSubmit={(values) => {
          console.log("Form submitted", values);
        }}
      >
        {(formikProps) => (
          <Form>
            <>
              <Modal
                open={isModalVisible}
                onCancel={() => {
                  setIsModalVisible(false);
                  setErrorModalVisible("");
                }}
                footer={null}
                centered
              >
                <p style={{ color: "red" }}>{modalMessage}</p>
                {errorModalVisible && (
                  <p style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
                    {errorModalVisible}
                  </p>
                )}
                <div className="flex items-center gap-3 mt-3">
                  <Form.Item style={{ flex: 1, marginBottom: 0 }}>
                    <Field name="access_code">
                      {() => (
                        <Input
                          placeholder="Enter an access code"
                          value={tempAccessCode}
                          onChange={(e) => setTempAccessCode(e.target.value)}
                        />
                      )}
                    </Field>
                  </Form.Item>

                  <Button onClick={() => {
                    if (!tempAccessCode.trim()) {
                      setErrorModalVisible("Please Enter AccessCode");
                      return;
                    }
                    setErrorModalVisible("");
                    formikProps.setFieldValue("access_code", tempAccessCode);
                    setIsModalVisible(false);
                    parseLogcardText(logcardText, formikProps,);
                  }
                  }
                    className="!w-[100px]"
                    type="primary"
                  >
                    Extract
                  </Button>
                </div>

              </Modal>
              <Modal
                open={errorModalVisible}
                title="Validation Errors"
                centered
                onOk={() => setErrorModalVisible(false)}
                onCancel={() => setErrorModalVisible(false)}
                okText="Close"
                cancelButtonProps={{ style: { display: 'none' } }}
                width={500}
                footer={
                  <div className="flex justify-center gap-3">
                    <Button
                      addClass="primary"
                      onClick={() => {
                        setErrorModalVisible(false);
                        reset();
                        setLogcardText('');
                        setIsParsed(false);
                      }}
                    >
                      Upload again
                    </Button>
                    <Button
                      addClass="primary"
                      onClick={() => {
                        setErrorModalVisible(false);
                        const savedUrl = localStorage.getItem("loanQueryUrl");
                        if (savedUrl) {
                          navigate(savedUrl);
                        } else {
                          navigate("/");
                        }
                        // window.location.href = "/";
                      }
                      }
                    >
                      Re-select loan product
                    </Button>
                  </div>
                }
              >
                <ul className="flex flex-wrap gap-4 text-red-600 list-none p-0 m-0">
                  <li className="inline-block">
                    {errorMessages}
                  </li>
                </ul>
              </Modal >
            </>

            <Fragment>
              <Row gutter={[24, 24]}>
                <Col xs={24} sm={24} md={24} lg={21}>
                  {!isParsed ? (
                    <>
                      <label className="form-field-label">Logcard Text Content</label>
                      <Form.Item className="mt-1">
                        <TextArea
                          rows={8}
                          value={logcardText}
                          onChange={(e) => setLogcardText(e.target.value)}
                          placeholder="Paste full Logcard text here..."
                        />
                      </Form.Item>
                      <Button
                        type="primary"
                        onClick={() => {
                          if (!validateAccessCode(formikProps)) return;
                          parseLogcardText(logcardText, formikProps);
                        }}
                        className="mt-2 ml-auto flex"
                        disabled={logcardText.trim() === ""}
                      >
                        Extract
                      </Button>
                    </>
                  ) : (
                    <div className="text-center mt-4">
                      <p className="text-green-600 font-semibold">
                        The data has been processed successfully. If you wish to redo it,
                        please click here
                      </p>
                      <Button onClick={() => { handleRedo(formikProps) }} className="mt-2" type="primary">
                        Redo
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>

              <Row gutter={[24, 24]} className="mb-5">
                <Col xs={24}>
                  {tag && (
                    <p className="bg-[#d9e4ed] px-[10px] py-[7px] rounded-[7px] text-[11px] font-bold inline-table">
                      {tag}
                    </p>
                  )}
                </Col>
              </Row>

              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Vehicle Reg No</label>
                  <Form.Item className="mt-1">
                    <Field name="vehicle_reg_no">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_reg_no?.validation == false && (
                      <span className="error">Vehicle Regno Required</span>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Access Code</label>
                  <Form.Item className="mt-1">
                    <Field name="access_code">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.access_code?.validation == false && (
                      <span className="error">Access Code Required</span>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Make/Model</label>
                  <Form.Item className="mt-1">
                    <Field name="make_model">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.make_model?.validation == false && (
                      <span className="error">Make Model Required</span>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Purchase Price</label>
                  <Form.Item className="w-full mt-1">
                    <Field name="vehicle_purchase_price">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_purchase_price?.validation ==
                      false && (
                        <span className="error">
                          Vehicle Purchase Price Required
                        </span>
                      )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Selling Price</label>
                  <Form.Item className="w-full mt-1">
                    <Field name="selling_price">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.selling_price?.validation ==
                      false && (
                        <span className="error">
                          Selling Price Required
                        </span>
                      )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Loan to Value Percentage</label>
                  <Form.Item className="mt-1">
                    <Field name="loan_to_value">
                      {({ field }) => (
                        <Input
                          {...field}
                          disabled 
                          addonAfter="%" 
                        />
                      )}
                    </Field>
                    {validationDetails?.loan_to_value?.validation == false && (
                      <span className="error">Loan to value Required</span>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Engine No</label>
                  <Form.Item className="mt-1">
                    <Field name="vehicle_engine_no">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_engine_no?.validation ==
                      false && (
                        <span className="error">
                          Vehicle Engine No Required
                        </span>
                      )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Chassis No</label>
                  <Form.Item className="w-full mt-1">
                    <Field name="vehicle_chassis_no">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_chassis_no?.validation ==
                      false && (
                        <span className="error">
                          Vehicle Chassis No Required
                        </span>
                      )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">
                    Ori.Reg Date (Overseas)
                  </label>
                  <Form.Item className="mt-1">
                    <Field name="vehicle_ori_reg_date">
                      {({ field }) => (
                        <DatePicker
                          placeholder="DD-MM-YYYY"
                          className="w-full"
                          allowClear={false}
                          format="DD-MM-YYYY"
                          {...field}
                          value={
                            vehicelDetail.vehicle_ori_reg_date
                              ? dayjs(vehicelDetail.vehicle_ori_reg_date)
                              : ""
                          }
                          name="vehicle_ori_reg_date"
                          onChange={(date) => {
                            handleDropdownChange(
                              "vehicle_ori_reg_date",
                              dayjs(date).format("YYYY-MM-DD"),
                              formikProps
                            );
                          }}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_ori_reg_date?.validation ==
                      false && (
                        <span className="error">Vehicle Reg Date Required</span>
                      )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">
                    COE-QP / PQP Paid
                  </label>
                  <Form.Item className="mt-1">
                    <Field name="vehicle_coe_amount">
                      {({ field }) => (
                        <Input
                          {...field}
                          value={currencyFormatter(field.value)}
                          onChange={(e) => {
                            const rawValue = currencyParser(e.target.value);
                            formikProps.setFieldValue("vehicle_coe_amount", rawValue);
                          }}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_coe_amount?.validation ==
                      false && (
                        <span className="error">COE Amount Required</span>
                      )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">ARF Paid</label>
                  <Form.Item className="mt-1">
                    <Field name="arf_paid">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.arf_paid?.validation == false && (
                      <span className="error">ARF Paid Required</span>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Transfer count</label>
                  <Form.Item className="mt-1">
                    <Field name="transfer_count">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.transfer_count?.validation == false && (
                      <span className="error">Transfer count Required</span>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 24]} >
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">Y.O.M</label>
                  <Form.Item className="mt-1">
                    <Field name="vehicle_yom">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_yom?.validation == false && (
                      <span className="error">Vehicle YOM Required</span>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                  <label className="form-field-label">OMV</label>
                  <Form.Item className="mt-1">
                    <Field name="vehicle_omv">
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.vehicle_omv?.validation == false && (
                      <span className="error">OMV Required</span>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16} className="input-one-line-dealer">
                <Col xs={24} sm={12} md={12} lg={12}>
                  <div className="input-group w-full">
                    <label>Is this an OPC Vehicle?</label>
                    <Form.Item className="mt-1">
                      <Field name="opc_vehicle_id">
                        {({ field }) => (
                          <Radio.Group
                            {...field}
                            // onChange={(e) => handleChange(e, formikProps)}
                            onChange={(e) => {
                              field.onChange(e); // ✅ update Formik
                              handleChange(e, formikProps); // ✅ custom logic
                            }}
                            value={field.value ?? 0}
                          >
                            <Radio key={0} value={0} disabled={opcSearch}>
                              <p className="form-field-label">No</p>
                            </Radio>
                            {opcData != undefined &&
                              opcData.length > 0 &&
                              opcData.map((data) => (
                                <Radio
                                  key={data.id}
                                  value={data.id}
                                  disabled={!opcSearch}
                                >
                                  <p className="form-field-label">{data.title}</p>
                                </Radio>
                              ))}
                          </Radio.Group>
                        )}
                      </Field>
                      <br />
                      {validationDetails?.opc_vehicle_id?.validation == false &&
                        validationDetails?.opc_vehicle_id == "" && (
                          <span className="error">OPC Vehicle Type Required</span>
                        )}
                    </Form.Item>

                  </div>
                </Col>
              </Row>
            </Fragment>
          </Form>
        )}
      </Formik>

    </div >
  );
};

export default VehicleDetails;
